import React from 'react'
import type { CSSProperties } from 'react'

import SPARKLES_LOADING from '@public/assets/Sparkles_Loader.gif'
import { cn } from '@utils/mergeClassNames'

interface SparklesLoaderProps {
  className?: string
  label?: string
  size?: number
  style?: CSSProperties
}

export function SparklesLoader({
  className,
  label = 'Loading',
  size = 150,
  style,
}: SparklesLoaderProps) {
  return (
    <img
      src={SPARKLES_LOADING}
      alt={label}
      className={cn('block shrink-0 object-contain', className)}
      height={size}
      width={size}
      style={{ height: size, width: size, ...style }}
    />
  )
}
